import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import _ from "lodash";

import Button from "../../components/Button/Button.jsx";
import Checkbox from "../../components/Checkbox/Checkbox.jsx";

import ButtonsGroup from "../../components/ButtonsGroup/ButtonsGroup.jsx";
import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";

import USelect from "../../components/Select/USelect.jsx";
import Input from "../../components/Input/Input.jsx";
import ModalFormFeedback from "../../features/ModalFormFeedback.jsx";

import actions from "../../store/actions.js";
import { APP_ROUTES } from "../../router";

import CityListContext from "../../context/cityList";
import { useAddress } from "../../hooks/useAddress.js";

import apiFetchUserLocation from "../../api/methods/apiFetchUserLocation.js";
import handleChangePhoneNumber from "../../utils/helpers/handleChangePhoneNumber";

import handleChangeFullName from "../../utils/helpers/handleChangeFullName";
import checkPhoneNumberLength from "../../utils/helpers/checkPhoneNumberLength.js";

import {
  AGREEMENT,
  PRIVATE_DATA_POLICY,
  ADS,
  OFFER_SBER,
  OFFER_DEFAULT,
} from "../../utils/consts/index.js";

const PersonalDataHome = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const { mobileConnectionInfo } = useSelector(state => state);
  const cityList = useContext(CityListContext);

  const {
    userCity,
    setUserCity,
    userStreet,
    setUserStreet,
    userHouse,
    setUserHouse,
    userFlat,
    setUserFlat,
    changeCity,
    changeStreet,
    changeHouse,
    changeFlat,
    refCity,
    refStreet,
    refHouse,
    userCityErrorText,
    userStreetErrorText,
    userHouseErrorText,
    userFlatErrorText,
    debouncedLoadStreetList,
    debouncedLoadHouseList,
  } = useAddress();
  // TODO: upgrade by RHF

  const [userFullName, setUserFullName] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");

  const [fullNameErrorText, setFullNameErrorText] = useState([]);
  const [userPhoneNumberErrorText, setUserPhoneNumberErrorText] = useState([]);

  const [hasFlat, setHasFlat] = useState(false);
  const [isOpenModalFormFeedback, setIsOpenModalFormFeedback] = useState(false);

  const [agreements, setAgreements] = useState({
    offerta: false,
    policy: false,
    ads: false,
  });

  useEffect(() => {
    (async () => {
      const regExp = /.+start\/([A-Za-z]+)/g;
      const urlSegment = window.location.href.replace(regExp, "$1");

      if (urlSegment === "alpha") localStorage.setItem("partnerProgram", "alpha");

      if (!_.isEmpty(mobileConnectionInfo)) {
        getUserInfoFromLocaleStorage();
      } else {
        await getAddressByIp();
      }
    })();
  }, []);

  const getAddressByIp = async () => {
    const { city, street, house } = (await apiFetchUserLocation()) || {};

    setUserCity(city || userCity);
    setUserStreet(street || userStreet);
    setUserHouse(house || userHouse);
  };

  const getUserInfoFromLocaleStorage = () => {
    const { city, street, house, flat, fullName, phoneNumber } = mobileConnectionInfo;

    setUserCity(city || "");
    setUserStreet(street || "");

    setUserHouse(house || "");
    setUserFlat(flat || "");

    setUserFullName(fullName || "");
    setUserPhoneNumber(phoneNumber || "");
  };

  const saveUserInfoToLocaleStorage = () => {
    const initialUrl =
      mobileConnectionInfo?.refUserId && mobileConnectionInfo?.refUserId !== "-"
        ? mobileConnectionInfo?.initialUrl
        : window.location.href;

    dispatch(
      actions.mobileConnection.changeConnectionData({
        ...mobileConnectionInfo,
        refUserId: mobileConnectionInfo?.refUserId || "-",
        city: userCity,
        street: userStreet,
        house: userHouse,
        flat: userFlat.length ? userFlat.trim() : null,
        fullName: userFullName.trim(),
        phoneNumber: userPhoneNumber,
        initialUrl: initialUrl,
      })
    );
  };

  const redirectToNextStep = () => {
    saveUserInfoToLocaleStorage();
    history(APP_ROUTES.MOBILE_CONNECTION.CONFIRM_PHONE_NUMBER_ROUTE);
  };

  const handleChangeHasFlat = () => {
    setUserFlat("");
    setHasFlat(prevState => !prevState);
  };

  const isReferralSber = mobileConnectionInfo.refUserId?.toLowerCase()?.indexOf("s") !== -1;

  const isFillPhoneNumber = checkPhoneNumberLength(userPhoneNumber);
  const isFillRequiredFields =
    userCity &&
    userStreet &&
    userHouse &&
    ((!userFlat && hasFlat) || (userFlat && !hasFlat)) &&
    userFullName &&
    agreements.offerta &&
    agreements.policy &&
    isFillPhoneNumber;

  return (
    <>
      <WrapperContainer title="sm" gap="16">
        Подключение услуг
      </WrapperContainer>

      <WrapperContainer gap="24">Укажите Ваш адрес и контактные данные</WrapperContainer>

      <WrapperContainer gap="16">
        <USelect
          isSearchable
          isClearable
          options={cityList}
          getOptionValue={option => option.alias}
          getOptionLabel={option => option.title}
          placeholder="Город"
          onChange={changeCity}
          value={userCity}
          ref={refCity}
          validationErrors={userCityErrorText}
        />
      </WrapperContainer>

      <WrapperContainer gap="16">
        <USelect
          isAsync
          isSearchable
          isClearable
          options={debouncedLoadStreetList}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.title}
          placeholder="Улица"
          onChange={changeStreet}
          value={userStreet}
          ref={refStreet}
          validationErrors={userStreetErrorText}
        />
      </WrapperContainer>

      <WrapperContainer gap="4">
        <USelect
          isAsync
          isSearchable
          isClearable
          options={debouncedLoadHouseList}
          getOptionValue={option => option.identifire}
          getOptionLabel={option => `${option.house}${option.frac}`}
          placeholder="Дом/корпус"
          onChange={changeHouse}
          value={userHouse}
          ref={refHouse}
          validationErrors={userHouseErrorText}
        />
      </WrapperContainer>
      <WrapperContainer gap="16" text="md">
        <div className="link clickable" onClick={() => setIsOpenModalFormFeedback(true)}>
          Моего адреса нет в списке
        </div>
      </WrapperContainer>

      <WrapperContainer gap="4">
        <Input
          placeholder="Квартира"
          onChange={changeFlat}
          value={userFlat}
          maxLength={5}
          disabled={hasFlat}
          validationErrors={userFlatErrorText}
        />
      </WrapperContainer>
      <WrapperContainer gap="16" text="md">
        <div className="link clickable" onClick={handleChangeHasFlat}>
          {!hasFlat ? "У меня частный дом" : "Указать квартиру"}
        </div>
      </WrapperContainer>
      <WrapperContainer gap="16">
        <Input
          placeholder="ФИО"
          onChange={handleChangeFullName(setFullNameErrorText, setUserFullName)}
          value={userFullName}
          validationErrors={fullNameErrorText}
        />
      </WrapperContainer>

      <WrapperContainer gap="16">
        <Input
          type="tel"
          placeholder="Номер телефона"
          onChange={handleChangePhoneNumber(setUserPhoneNumberErrorText, setUserPhoneNumber)}
          value={userPhoneNumber}
          validationErrors={userPhoneNumberErrorText}
        />
      </WrapperContainer>

      <WrapperContainer gap="24">
        <WrapperContainer gap="16">
          <Checkbox
            onChange={() =>
              setAgreements(prevState => ({
                ...prevState,
                offerta: !prevState.offerta,
              }))
            }
            checked={agreements.offerta}
          >
            <div>
              Я соглашаюсь с условиями{" "}
              <a
                className="link"
                href={isReferralSber ? OFFER_SBER : OFFER_DEFAULT}
                target="_blank"
                rel="noreferrer"
              >
                оферты
              </a>
            </div>
          </Checkbox>
        </WrapperContainer>

        <WrapperContainer gap="16">
          <Checkbox
            onChange={() =>
              setAgreements(prevState => ({
                ...prevState,
                policy: !prevState.policy,
              }))
            }
            checked={agreements.policy}
          >
            <div>
              Я даю{" "}
              <a className="link" href={AGREEMENT} target="_blank" rel="noreferrer">
                согласие на обработку моих персональных данных
              </a>{" "}
              в соответствии с{" "}
              <a className="link" href={PRIVATE_DATA_POLICY} target="_blank" rel="noreferrer">
                политикой в отношении обработки персональных данных
              </a>
            </div>
          </Checkbox>
        </WrapperContainer>

        <WrapperContainer gap="16">
          <Checkbox
            onChange={() =>
              setAgreements(prevState => ({
                ...prevState,
                ads: !prevState.ads,
              }))
            }
            checked={agreements.ads}
          >
            <div>
              Я даю{" "}
              <a className="link" href={ADS} target="_blank" rel="noreferrer">
                согласие на получение сообщений рекламно-информационного характера
              </a>
            </div>
          </Checkbox>
        </WrapperContainer>
      </WrapperContainer>

      <ButtonsGroup>
        <Button isStretch size="xxl" color="secondary" onClick={() => history(-1)}>
          Назад
        </Button>
        <Button
          isStretch
          size="xxl"
          color="primary"
          onClick={redirectToNextStep}
          disabled={!isFillRequiredFields}
        >
          Далее
        </Button>
      </ButtonsGroup>

      {isOpenModalFormFeedback && (
        <ModalFormFeedback
          isOpenModal={isOpenModalFormFeedback}
          closeModal={() => setIsOpenModalFormFeedback(false)}
        />
      )}
    </>
  );
};

export default PersonalDataHome;
